import { useLanguage } from '@/i18n/LanguageContext';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';


const HeroSection = () => {
  const { t } = useLanguage();

  return (
    <section id="hero" className="relative flex min-h-screen items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1552832230-c0197dd311b5?w=800&q=70&fm=webp"
          alt="Rome cityscape"
          className="h-full w-full object-cover"
          loading="eager" />

        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-background dark:from-background/70 dark:via-background/50 dark:to-background" />
      </div>

      <div className="relative z-10 mx-auto max-w-4xl px-6 text-center">
        {/* Logo rendered immediately without JS animation dependency */}
        <img src="/logo-roma-dream-escape.png" alt="Roma Dream Escape" className="mx-auto mb-6 h-48 w-auto md:h-64 lg:h-[17.5rem] animate-[fadeInUp_1s_0.3s_both]" fetchPriority="high" width="1344" height="768" />
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3 }}>

          <h1 className="font-serif text-4xl font-light leading-tight tracking-wide text-white dark:text-foreground md:text-6xl lg:text-7xl">
            {t.hero.title}
          </h1>
          <p className="mt-6 font-sans text-base md:text-lg font-medium text-white/90 dark:text-gold-light">
            {t.hero.subtitle}
          </p>
          <a
            href="#apartments"
            className="mt-10 inline-block rounded-none border border-white/40 dark:border-primary/30 px-10 py-4 font-sans text-xs uppercase tracking-[0.25em] text-white dark:text-primary transition-all duration-300 hover:bg-primary hover:text-primary-foreground dark:hover:text-primary-foreground hover:border-primary">

            {t.hero.cta}
          </a>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div
        animate={{ y: [0, 10, 0] }}
        transition={{ repeat: Infinity, duration: 2 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2">

        <ChevronDown className="h-6 w-6 text-primary/50" />
      </motion.div>
    </section>);

};

export default HeroSection;